import { Form, Input } from 'antd';
import React, { useState } from 'react';
import { validatePartitaIVA } from '../../utils/validatePartitaIVA';
import { ItalianAddressInput } from '@virlewood/board-79';
import { $api } from '../../utils/openApiClient';
import { useQueryClient } from '@tanstack/react-query';
import { NButton, type NButtonProps } from '@next-is-free-monorepo/nif-web-components';


interface BillingsDataFormProps {
  onSuccess?: () => void;
  submitButtonProps?: NButtonProps;
}

const BillingsDataForm = ({ submitButtonProps, onSuccess }: BillingsDataFormProps) => {

  const [disabled, setDisabled] = useState(true);

  const [form] = Form.useForm();

  const queryClient = useQueryClient();

  const billingData = $api.useSuspenseQuery('get', '/shop/billing-data');

  const saveBillingData = $api.useMutation('put', '/shop/billing-data', {
    onSuccess: async () => {
      if (onSuccess) {
        onSuccess();
      }
      setDisabled(true);
      await queryClient.invalidateQueries({ queryKey: ['get', '/shop/billing-data'] });
    },
    onError: async (error) => {
      alert(error);
    }
  });



  return (
    <Form onValuesChange={() => setDisabled(false)} form={form} initialValues={billingData.data}
          onFinish={(values) => saveBillingData.mutate({ body: { ...values, tax_code: values.tax_code || undefined } })}
          layout={'vertical'} style={{ textAlign: 'right' }}>

      <Form.Item rules={[
        {
          required: true,
          message: 'Inserisci il nome o la ragione sociale'
        }
      ]} required={false} label={'Nome o ragione sociale'} name={'legal_name'}>
        <Input size={'large'} placeholder={'Nome o ragione sociale'} />
      </Form.Item>
      <Form.Item validateDebounce={2000} hasFeedback rules={[
        {
          validator: (_, value) => {
            if (validatePartitaIVA(value)) {
              return Promise.resolve();
            } else {
              return Promise.reject('Partita Iva non corretta');
            }
          }
        }
      ]}
                 required={false}
                 name={'vat'} label={'Partita IVA'}>
        <Input size={'large'} placeholder={'Partita IVA'} />
      </Form.Item>
      <Form.Item validateDebounce={2000}
                 required={false} style={{textAlign: 'left'}}
                 name={'tax_code'} label={'Codice Fiscale'} extra={'Obbligatorio se sei una persona fisica (libero professionista o ditta individuale)'}>
        <Input size={'large'} placeholder={'Codice Fiscale'} />
      </Form.Item>
      <Form.Item name={'billing_address'} label={'Indirizzo di fatturazione'}>
        <ItalianAddressInput availableModes={['manual']} defaultMode={'manual'} />
      </Form.Item>
      <Form.Item rules={[
        {
          required: true,
          message: 'Inserisci il codice destinatario'
        }
      ]}
                 required={false}
                 name={'sdi_code'} label={'Codice destinatario SDI'}>
        <Input size={'large'} placeholder={'Codice Univoco'} />
      </Form.Item>
      <NButton disabled={submitButtonProps?.disabled ?? disabled} className={submitButtonProps?.className}
               onClick={() => form.submit()}
               color={submitButtonProps?.color ?? 'secondary'}>{submitButtonProps?.children ?? 'Salva'}</NButton>
    </Form>
  );
};
export default BillingsDataForm;
